import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';

import Topbar from './scenes/global/topbar';
import Footer from './scenes/global/footer';

import Home from './scenes/home';
import About from './scenes/about';
import Solutions from './scenes/solutions';
import Districts from './scenes/districts';
import Testimonials from './scenes/testimonials';
import Careers from './scenes/careers';
import Contact from './scenes/contact';
import Labs from './scenes/labs';
import Social from './scenes/social';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                {/* Top navigation bar on every page */}
                <Topbar />

                {/* Main content area */}
                <Box component="main" sx={{ flex: 1, p: 3, bgcolor: 'background.default' }}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/solutions" element={<Solutions />} />
                        <Route path="/districts" element={<Districts />} />
                        <Route path="/testimonials" element={<Testimonials />} />
                        <Route path="/careers" element={<Careers />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/labs" element={<Labs />} />
                        <Route path="/social" element={<Social />} />
                        {/* Add additional routes here */}
                    </Routes>
                </Box>

                {/* Footer on every page */}
                <Footer />
            </Box>
        </ThemeProvider>
    );
}

export default App;